import { useState, useEffect } from "react";
import { checkConnection, getStoredWPEndpoint, updateWPEndpoint } from "../lib/wordpress";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "./ui/use-toast";
import { Link } from "react-router-dom";

const WordPressSetup = () => {
  const [endpoint, setEndpoint] = useState(getStoredWPEndpoint());
  const [isConnected, setIsConnected] = useState<boolean | null>(null);
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    checkConnection();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsChecking(true);

    try {
      const connected = await checkConnection();
      setIsConnected(connected);
      if (connected) {
        updateWPEndpoint(endpoint);
        toast({
          title: "URL Updated",
          description: "WordPress GraphQL URL has been updated",
        });
      }
    } catch (error) {
      setIsConnected(false);
      console.error('Error checking connection:', error);
      toast({
        title: "Connection Failed",
        description: "Could not connect to WordPress GraphQL API. Please check your endpoint and ensure CORS is properly configured.",
        variant: "destructive"
      });
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="endpoint" className="block text-sm font-medium text-gray-700">
            GraphQL Endpoint
          </label>
          <input
            type="url"
            id="endpoint"
            value={endpoint}
            onChange={(e) => setEndpoint(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            placeholder="http://localhost:10212/graphql"
            required
          />
        </div>

        <div>
          <button
            type="submit"
            disabled={isChecking}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
          >
            {isChecking ? 'Checking Connection...' : 'Test Connection'}
          </button>
        </div>

        {isConnected !== null && (
          <div className={`mt-4 p-4 rounded-md ${isConnected ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`}>
            {isConnected ? (
              <p>✓ Connection successful! The endpoint has been updated.</p>
            ) : (
              <p>✗ Connection failed. Please check the endpoint and try again.</p>
            )}
          </div>
        )}
      </form>
    </div>
  );
};

export default WordPressSetup;
